import React from 'react';

import './styles.css';

const AdminInformation = ({admin}) => {
  return (
    <div className="AdminInformation">
      <div className="name">{admin.fullName}</div>
      <div className="email">{admin.email}</div>
    </div>
  );
};

export default AdminInformation;
